import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import '../styles/navigation-redesign.css';
import {
  ChevronDown,
  Menu,
  X,
} from 'lucide-react';

const groups = {
  Services: [
    [
      'SME Solutions',
      'Specialized solutions for small and medium enterprises',
      '/services/sme',
    ],
    [
      'Large Enterprise',
      'Comprehensive services for enterprise organizations',
      '/services/large-enterprise',
    ],
    [
      'Expert Consultancy',
      'Professional guidance and strategic planning',
      '/services/consultancy',
    ],
  ],
  'Success Stories': [
    [
      'SME Success Stories',
      'Real results from small business migrations',
      '/success-stories/sme',
    ],
    [
      'Enterprise Stories',
      'Large-scale transformation case studies',
      '/success-stories/large-enterprise',
    ],
    [
      'Consultancy Results',
      'Strategic consulting outcomes',
      '/success-stories/consultancy',
    ],
  ],
};
export default function AppleNavigation() {
  const [open, setOpen] = useState(null);
  const [mobile, setMobile] = useState(false);
  const nav = useRef(null);
  const toggles = useRef({});
  const mobileToggle = useRef(null);
  const location = useLocation();
  useEffect(() => {
    setOpen(null);
    setMobile(false);
  }, [location.pathname]);
  useEffect(() => {
    const outside = (e) => {
      if (!nav.current?.contains(e.target)) {
        setOpen(null);
        setMobile(false);
      }
    };
    const resize = () => {
      if (window.innerWidth > 1100) setMobile(false);
    };
    document.addEventListener('pointerdown', outside);
    window.addEventListener('resize', resize);
    return () => {
      document.removeEventListener('pointerdown', outside);
      window.removeEventListener('resize', resize);
    };
  }, []);
  const escape = (e) => {
    if (e.key === 'Escape') {
      if (open) {
        toggles.current[open]?.focus();
        setOpen(null);
      } else {
        setMobile(false);
        mobileToggle.current?.focus();
      }
    }
  };
  return (
    <header
      className='gpm-header gpm-nav-redesign'
      ref={nav}
      onKeyDown={escape}
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
          setOpen(null);
          setMobile(false);
        }
      }}
    >
      <div className='gpm-shell gpm-nav-row'>
        <Link to='/' className='gpm-brand' aria-label='Global Payroll Migration home'>
          <img className='gpm-original-logo' src='/images/gpm-logo.png' alt='GPM Logo' />
          <span className='gpm-brand-name'>Global Payroll Migration</span>
        </Link>
        <nav
          aria-label='Main navigation'
          id='gpm-navigation'
          className={`gpm-nav-links ${mobile ? 'is-open' : ''}`}
        >
          <NavLink to='/' end>
            Home
          </NavLink>
          {Object.entries(groups).map(([name, items]) => (
            <div className='gpm-nav-group' key={name}>
              <button
                ref={(el) => {
                  toggles.current[name] = el;
                }}
                className={items.some(([, , path]) => location.pathname.startsWith(path)) ? 'is-current' : ''}
                aria-expanded={open === name}
                aria-controls={`gpm-${name.replaceAll(' ', '-')}`}
                onClick={() => setOpen(open === name ? null : name)}
              >
                {name}
                <ChevronDown size={14} className={open === name ? 'is-rotated' : ''} />
              </button>
              {open === name && (
                <div className='gpm-dropdown' id={`gpm-${name.replaceAll(' ', '-')}`}>
                  <div className='gpm-dropdown-grid'>
                  {items.map(([title, desc, path], index) => (
                    <Link to={path} key={path} className={`gpm-menu-card gpm-menu-card-${index}`}>
                      <span>
                        <strong>{title}</strong>
                        <small>{desc}</small>
                      </span>
                    </Link>
                  ))}
                  </div>
                </div>
              )}
            </div>
          ))}
          <NavLink to='/about'>About</NavLink>
          <NavLink to='/blog'>Blog</NavLink>
          <NavLink to='/contact'>Contact</NavLink>
          <NavLink className='gpm-mobile-faq' to='/faq'>
            FAQ
          </NavLink>
          <Link className='gpm-mobile-consult' to='/contact'>
            Free Consultation
          </Link>
        </nav>
        <Link to='/contact' className='gpm-nav-cta'>
          Free Consultation
        </Link>
        <button
          className='gpm-menu-toggle'
          ref={mobileToggle}
          aria-label={mobile ? 'Close navigation' : 'Open navigation'}
          aria-controls='gpm-navigation'
          aria-expanded={mobile}
          onClick={() => setMobile(!mobile)}
        >
          {mobile ? <X size={23} /> : <Menu size={23} />}
        </button>
      </div>
    </header>
  );
}
